import { render, staticRenderFns } from "./MetodosPago.vue?vue&type=template&id=3aad98c6"
import script from "./MetodosPago.vue?vue&type=script&lang=js"
export * from "./MetodosPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports